import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Warehouse, Warehouse1 } from '../../../warehouse';
import { WarehouseProfilesForm } from '../warehouse-profiles-form';
import { CintacValidators } from '../../../../_shared/cintac-validators';
import { SteelProfileService } from '../../../../steel-profile/steel-profile.service';
import { WarehouseParamsFormService } from '../../warehouse-params-forms/warehouse-params-form.service';
import { isNullOrUndefined } from 'util';
import { WarehouseService } from '../../../warehouse.service';


@Component({
  templateUrl: './warehouse1-profiles-form.component.html',
  styleUrls: ['../../project-form.css']
})
export class Warehouse1ProfilesFormComponent implements OnInit, WarehouseProfilesForm {
  @Input() warehouse: Warehouse1;
  whForm: AbstractControl;
  public calculated: boolean;
  selected: string;
  result: any;
  elements = [1, 2, 3, 4];
  displacementSelected: string;
  stressSelected: string;
  stressModal = false;
  rebarModal = false;
  displacementModal = false;

  @ViewChild('modalRebarBtn') private detailRebarModal: ElementRef;
  @ViewChild('modalCloseRebarBtn') private detailRebarCloseModal: ElementRef;

  @ViewChild('modalDisplacementBtn') private detailDisplacementModal: ElementRef;
  @ViewChild('modalCloseDisplacementBtn') private detailDisplacementCloseModal: ElementRef;

  @ViewChild('modalStressBtn') private detailStressModal: ElementRef;
  @ViewChild('modalCloseStressBtn') private detailStressCloseModal: ElementRef;

  labels = {
    profile_type: 'Tipo de Perfil',
    profile: 'Perfil'
  };

  profileTypes = [];
  profileSelectOptions = {};
  profiles = [];
  supportConditions = Warehouse.getSupportConditions();
  inputFocus: string;

  formErrors = {
    displacement_x: '',
    displacement_y: '',
    profile_1: '',
    profile_2: '',
    profile_3: '',
    profile_4: '',
    hb_additional_height: '',
  };

  profileMsg = 'Seleccionar perfil';
  displacementRequiredMsg = 'Ingresar desplazamiento';
  displacementValidMsg = CintacValidators.getPositiveFloatValidatorMessage();

  validationMessages = {
    displacement_x: {
      required: this.displacementRequiredMsg,
      pattern: this.displacementValidMsg
    },
    displacement_y: {
      required: this.displacementRequiredMsg,
      pattern: this.displacementValidMsg
    },
    profile_1: {
      required: this.profileMsg
    },
    profile_2: {
      required: this.profileMsg
    },
    profile_3: {
      required: this.profileMsg
    },
    profile_4: {
      required: this.profileMsg
    },
    hb_additional_height: {
      required: 'Ingresar valor positivo'
    }
  };

  constructor(private fb: FormBuilder,
    private warehouseFormService: WarehouseParamsFormService,
    private profileService: SteelProfileService,
    private warehouseService: WarehouseService) {
    this.whForm = this.fb.group({
      profile_0_type: [null, []],
      profile_0: [null, []],
      profile_1_type: [null, []],
      profile_1: [null, [Validators.required]],
      profile_2_type: [null, []],
      profile_2: [null, [Validators.required]],
      profile_3_type: [null, []],
      profile_3: [null, [Validators.required]],
      profile_4_type: [null, []],
      profile_4: [null, [Validators.required]],
      displacement_y: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
      displacement_x: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
      hb_additional_height: [0, []],
      has_hb: [null, [Validators.required]],
      hbl: [null, [Validators.required]],
      hbr: [null, [Validators.required]],
      sc: [null, [Validators.required]],
      snow: [null, [Validators.required]],
      po: [null, [Validators.required]],
      pb: [null, [Validators.required]],
      uf: [null, [Validators.required]],
      suggested_profile: [null, [Validators.required]],
    });
  }

  ngOnInit() {

    this.whForm.patchValue({
      displacement_x: this.warehouse.displacement_x,
      displacement_y: this.warehouse.displacement_y,
      has_hb: this.warehouse.has_hb,
      hb_additional_height: this.warehouse.hb_additional_height,
      uf: this.warehouse.uf,
      suggested_profile: this.warehouse.suggested_profile,
    });

    this.whForm.valueChanges.subscribe(values => this.onValueChanged());

    this.profileService.getWindColumns().subscribe((profiles) => {
        const types: Map<number, string> = new Map();
        let type1 = null;
        let type2 = null;
        let type3 = null;
        let type4 = null;

        this.profileTypes = [];
        Object.keys(profiles).forEach((key) => {
          this.profileTypes.push({ label: profiles[key].name, value: +key });
          this.profileSelectOptions[key] = profiles[key].list;
          for (const object of Object.keys(profiles[key].list)) {
            if (profiles[key].list[object].id === this.warehouse.profile_1) {
              type1 = +key;
            }
            if (profiles[key].list[object].id === this.warehouse.profile_2) {
              type2 = +key;
            }
            if (profiles[key].list[object].id === this.warehouse.profile_3) {
              type3 = +key;
            }
            if (profiles[key].list[object].id === this.warehouse.profile_4) {
              type4 = +key;
            }
          }
        });

        this.whForm.patchValue({
          profile_1_type: type1,
          profile_2_type: type2,
          profile_3_type: type3,
          profile_4_type: type4,
          profile_1: this.warehouse.profile_1,
          profile_2: this.warehouse.profile_2,
          profile_3: this.warehouse.profile_3,
          profile_4: this.warehouse.profile_4,
        });

        this.warehouseService.distributed_load(this.warehouse.id).subscribe((data) => {
          this.warehouse.hbl = data["hbl"];
          this.warehouse.hbr = data["hbr"];
          this.warehouse.sc = data["sc"];
          this.warehouse.snow = data["snow"];
          this.warehouse.po = data["po"];
          this.warehouse.pb = data["pb"];
          this.whForm.patchValue({
            hbl: this.warehouse.hbl,
            hbr: this.warehouse.hbr,
            sc: this.warehouse.sc,
            snow: this.warehouse.snow,
            po: this.warehouse.po,
            pb: this.warehouse.pb,
          });
        });
      });
  }

  private onValueChanged() {
    if(this.whForm.value.hb_additional_height != null && this.whForm.value.hb_additional_height >= 0 && this.whForm.value.hb_additional_height != this.warehouse.hb_additional_height){
      this.warehouse.hb_additional_height = this.whForm.value.hb_additional_height;
      this.warehouseService.update(this.warehouse).subscribe((warehouse) => {
        // this.updateWarehouseData(warehouse);
        this.warehouseService.distributed_load(this.warehouse.id).subscribe((data) => {
          this.warehouse.pb = data["pb"];
          this.whForm.patchValue({
            pb: this.warehouse.pb
          });
        });
      });
    } else {
      this.updateWarehouse();
    }

    this.warehouseFormService.updateFormMessages(this.whForm, this.formErrors, this.validationMessages);
    if (this.whForm.value.hb_additional_height < 0 || this.whForm.value.hb_additional_height == null) {
      this.formErrors.hb_additional_height = this.validationMessages.hb_additional_height.required;
    }

  }

  updateWarehouse() {
    this.warehouse.profile_1 = +this.whForm.value.profile_1;
    this.warehouse.profile_2 = +this.whForm.value.profile_2;
    this.warehouse.profile_3 = +this.whForm.value.profile_3;
    this.warehouse.profile_4 = +this.whForm.value.profile_4;
    this.warehouse.displacement_x = +this.whForm.value.displacement_x;
    this.warehouse.displacement_y = +this.whForm.value.displacement_y;
    this.warehouse.has_hb = this.whForm.value.has_hb;
    this.warehouse.hb_additional_height = +this.whForm.value.hb_additional_height;
    this.warehouse.hbl = +this.whForm.value.hbl;
    this.warehouse.hbr = +this.whForm.value.hbr;
    this.warehouse.sc = +this.whForm.value.sc;
    this.warehouse.snow = +this.whForm.value.snow;
    this.warehouse.po = +this.whForm.value.po;
    this.warehouse.pb = +this.whForm.value.pb;
    this.warehouse.uf = +this.whForm.value.uf;
    this.warehouse.suggested_profile = this.whForm.value.suggested_profile;
  }

  updateWarehouseData(warehouse){
    this.warehouse.profile_1 = warehouse.profile_1;
    this.warehouse.profile_2 = warehouse.profile_2;
    this.warehouse.profile_3 = warehouse.profile_3;
    this.warehouse.profile_4 = warehouse.profile_4;
    this.warehouse.displacement_x = warehouse.displacement_x;
    this.warehouse.displacement_y = warehouse.displacement_y;
    this.warehouse.has_hb = warehouse.has_hb;
    this.warehouse.hb_additional_height = warehouse.hb_additional_height;
    this.warehouse.hbl = warehouse.hbl;
    this.warehouse.hbr = warehouse.hbr;
    this.warehouse.sc = warehouse.sc;
    this.warehouse.snow = warehouse.snow;
    this.warehouse.po = warehouse.po;
    this.warehouse.pb = warehouse.pb;
    this.warehouse.uf = warehouse.uf;
    this.warehouse.suggested_profile = warehouse.suggested_profile;
  }

  setAllProfiles() {
    this.whForm.patchValue({
      profile_1: this.whForm.value.profile_0,
      profile_2: this.whForm.value.profile_0,
      profile_3: this.whForm.value.profile_0,
      profile_4: this.whForm.value.profile_0,
      profile_1_type: this.whForm.value.profile_0_type,
      profile_2_type: this.whForm.value.profile_0_type,
      profile_3_type: this.whForm.value.profile_0_type,
      profile_4_type: this.whForm.value.profile_0_type
    });
  }

  getProfileSelectOptions(profileType) {
    if (isNullOrUndefined(profileType)) {
      return [];
    }
    return this.profileSelectOptions[profileType];
  }

  calculate(context = null, funct = null) {
    this.updateWarehouse();
    this.warehouseService.update(this.warehouse).subscribe((warehouse) => {
      this.updateWarehouseData(warehouse);
      this.warehouseService.calc(this.warehouse.id).subscribe((data) => {
        this.result = data;
        this.displacementSelected = this.getDisplacementKeys()[0];
        this.stressSelected = this.getStressKeys()[0];
        this.selected = this.elements[0]+"";
        this.calculated = true;
        this.warehouse.uf = this.result['disp'] && this.result['disp']['uf'];
        this.warehouse.suggested_profile = this.result['suggested_profile'] && this.result['suggested_profile']['name'];
        this.warehouse.po = this.result['distributed_load'] && this.result['distributed_load']['po'];
        this.warehouse.pb = this.result['distributed_load'] && this.result['distributed_load']['pb'];
        this.warehouse.sc = this.result['distributed_load'] && this.result['distributed_load']['sc'];
        this.warehouse.snow = this.result['distributed_load'] && this.result['distributed_load']['snow'];
        this.warehouse.hbl = this.result['distributed_load'] && this.result['distributed_load']['hbl'];
        this.warehouse.hbr = this.result['distributed_load'] && this.result['distributed_load']['hbr'];
        this.whForm.patchValue({
          uf: this.warehouse.uf,
          suggested_profile: this.warehouse.suggested_profile,
          po: this.warehouse.po,
          pb: this.warehouse.pb,
          sc: this.warehouse.sc,
          snow: this.warehouse.snow,
          hbl: this.warehouse.hbl,
          hbr: this.warehouse.hbr
        });
        if (context != null){
          funct.call(context, null);
          if (this.warehouse.uf) context.isCalculateProfile = true;
          context.finishCalculation();
        }
      }, (error) => {
        if (context != null){
          funct.call(context, null);
          context.finishCalculation();
        }
      });
    }, (error) => {
        if (context != null){
          funct.call(context, null);
          context.finishCalculation();
        }
    });
  }

  changeSelectBar(bar) {
    this.detailRebarModal.nativeElement.click();
    this.stressModal = false;
    this.displacementModal = false;
    this.rebarModal = true;
    this.selected = bar;
  }

  detailDisplacement() {
    this.detailDisplacementModal.nativeElement.click();
    this.stressModal = false;
    this.rebarModal = false;
    this.displacementModal = true;
  }

  getDisplacementKeys(){
    if(this.result['disp'] && this.result['disp']['values']) return Object.keys(this.result['disp']['values']);
    else return [];
  }

  getIDsDisplacementKeys(key){
    if(key && this.result['disp'] && this.result['disp']['values']) return Object.keys(this.result['disp']['values'][key]);
    else return [];
  }

  detailStress() {
    this.detailStressModal.nativeElement.click();
    this.rebarModal = false;
    this.displacementModal = false;
    this.stressModal = true;
  }

  getStressKeys(){
    if(this.result['stress']) return Object.keys(this.result['stress']);
    else return [];
  }

  getIDsStressKeys(key){
    if(key && this.selected && this.result['stress'] && this.result['stress'][key] && this.result['stress'][key][+this.selected-1] ){
      return Object.keys(this.result['stress'][key][+this.selected-1]);
    }
    else return [];
  }

}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-profiles-form/warehouse1-profiles-form/warehouse1-profiles-form.component.ts